<template>
  <div class="level" style="padding: 5px 10px; margin: 2px;">
    <!-- Total results and Sorting-->
    <div class="level-left">
      <!--Totla results-->
      <div class="level-item">
        <p class="subtitle is-6">
          <strong>{{ productsTotal }}</strong> results
        </p>
      </div>
      <!--Sorting-->
      <div class="level-item">
        <vue-select
          style="min-width: 220px"
          aria-label="email"
          @input="setPriceSorting"
          :options="$store.state.priceSortingOptions"
          :value="$store.state.priceSortingSelected"
          placeholder="sortirano po važnosti"
        />
      </div>
    </div>
    <!-- Pagination -->
    <div class="level-right" style="padding: 5px 10px; margin: 2px;">
      <div class="level-item">
        <paginate
          v-show="pageCount > 1"
          v-model="currentPageComputed"
          :page-count="pageCount"
          :margin-pages="1"
          :next-text="'Next'"
          :prev-text="'Prev'"
          :container-class="'pagination'"
          :page-class="'page-item'"
        ></paginate>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "PageControls",
  data() {
    return {};
  },
  components: { Paginate, VueSelect },
  computed: {
    ...mapState(["currentPage", "productsTotal"]),
    ...mapGetters(["pageCount"]),
    currentPageComputed: {
      get: function() {
        return this.currentPage;
      },
      set: function(newValue) {
        this.setCurrentPage(newValue);
      },
    },
  },
  methods: {
    ...mapActions(["setPriceSorting", "setCurrentPage"]),
    ...mapMutations(["SET_CURRENT_PAGE", "SET_RESULTS_PER_PAGE"]),
    changeProductsPerChange($event) {
      this.SET_RESULTS_PER_PAGE(Number($event.target.value));
    },
  },
};
</script>

<style lang="css">
.pagination {
  float: right;
  /*background-color: burlywood;*/
  /*padding: 20px;*/
  margin: 2px;
}

.pagination a {
  text-decoration: none;
  padding: 5px 10px;
  color: #2d4161;
}

li.page-item a:hover {
  background-color: #b9ede2;
}

li.active a {
  background-color: #2d4161;
  color: white;
}

li.active a:hover:not(:active) {
  background-color: #2d4161;
  color: white;
}
</style>
